import React from "react";

import { FullNameCellContent as Content } from "../components";

import base from "./base";

import { Column, ColumnId } from ".";

function fullName({ width, onResize }: Column.Options) {
	return base(ColumnId.FullName, (item) => <Content item={item} />, {
		width,

		onResize: onResize as (
			columnWidth?: number | undefined,
			dataKey?: string | undefined,
		) => void,
	});
}

export default fullName;
